var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5005 12.2331C22.5005 11.3698 22.4291 10.7398 22.2744 10.0864H12.2148V13.983H18.1196C18.0006 14.9514 17.3577 16.4097 15.9291 17.3897L15.9091 17.5202L19.0897 19.9349L19.3101 19.9564C21.3338 18.1247 22.5005 15.4297 22.5005 12.2331Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.212 22.5001C15.1048 22.5001 17.5334 21.5667 19.3072 19.9567L15.9263 17.39C15.0215 18.0083 13.8072 18.44 12.212 18.44C9.37874 18.44 6.974 16.6083 6.11678 14.0767L5.99113 14.0871L2.68388 16.5955L2.64062 16.7133C4.4025 20.1433 8.02155 22.5001 12.212 22.5001Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.119 14.0767C5.89281 13.4234 5.76191 12.7233 5.76191 12C5.76191 11.2767 5.89281 10.5767 6.1071 9.92337L6.10111 9.78423L2.75239 7.2356L2.64283 7.28667C1.91667 8.71002 1.5 10.3084 1.5 12C1.5 13.6917 1.91667 15.29 2.64283 16.7133L6.119 14.0767Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2121 5.55997C14.224 5.55997 15.5811 6.41163 16.3549 7.12335L19.3787 4.23C17.5216 2.53834 15.1049 1.5 12.2121 1.5C8.02158 1.5 4.40251 3.85665 2.64062 7.28662L6.1049 9.92332C6.97403 7.39166 9.37878 5.55997 12.2121 5.55997Z",
    fill: "#EB4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/GoogleIcon.3ad74f50634823ce35c2dbd9184a1238.svg";
export { ForwardRef as ReactComponent };